import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-007a967a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Open "),
    /*#__PURE__*/_createElementVNode("b", null, "Settings"),
    /*#__PURE__*/_createTextVNode(" on your phone")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Locate "),
    /*#__PURE__*/_createElementVNode("b", null, "DView"),
    /*#__PURE__*/_createTextVNode(" in the list")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Enable \""),
    /*#__PURE__*/_createElementVNode("b", null, "Allow Notifications"),
    /*#__PURE__*/_createTextVNode("\" for DView")
  ])
], -1))
const _hoisted_2 = { class: "ion-padding" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Notification Frequency", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body" }, " Set up a daily notification linking to the open deviations overview. ", -1))
const _hoisted_5 = { class: "toggle-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Notification Content", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body" }, "Select what to show in notifications", -1))
const _hoisted_9 = { class: "toggle-item" }
const _hoisted_10 = { class: "toggle-item last" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_DViewMessageBanner = _resolveComponent("DViewMessageBanner")!
  const _component_DViewModal = _resolveComponent("DViewModal")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { text: "" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Notification Settings")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          (_ctx.showPermissionWarning)
            ? (_openBlock(), _createBlock(_component_DViewMessageBanner, {
                key: 0,
                type: "warning",
                "banner-action-type": "navigate",
                onBannerClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen = true)),
                message: "Notifications are not allowed on your phone"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_DViewModal, {
            isModalOpen: _ctx.modalOpen,
            onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalOpen = false)),
            onCtaButtonAction: _ctx.openIOSAppSettingsForDView,
            showCtaButton: _ctx.iOSAppSettingsAvailable,
            showCloseButton: true,
            title: "Notifications are not allowed on your phone",
            ctaButtonText: "Notification settings"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["isModalOpen", "onCtaButtonAction", "showCtaButton"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ion_label, { class: "text-body" }, {
                default: _withCtx(() => [
                  _createTextVNode("Daily Notification at 08:00")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_toggle, {
                modelValue: _ctx.notificationsModel.mode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.notificationsModel.mode) = $event)),
                checked: _ctx.permission && _ctx.notificationsModel.mode,
                onIonChange: _ctx.toggleNotifications
              }, null, 8, ["modelValue", "checked", "onIonChange"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["toggleable-notification-areas", { hidden: !_ctx.notificationsModel.mode }])
            }, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ion_label, { class: "text-body" }, {
                  default: _withCtx(() => [
                    _createTextVNode("New Deviations")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.notificationsModel.newDeviations,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.notificationsModel.newDeviations) = $event)),
                  checked: _ctx.notificationsModel.newDeviations,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackNotificationTypeChange('Open deviations'))),
                  onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.autoSaveSettings()))
                }, null, 8, ["modelValue", "checked"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ion_label, { class: "text-body" }, {
                  default: _withCtx(() => [
                    _createTextVNode("New HoC Ratings")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.notificationsModel.newHocRatings,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.notificationsModel.newHocRatings) = $event)),
                  checked: _ctx.notificationsModel.newHocRatings,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trackNotificationTypeChange('HoC ratings'))),
                  onIonChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.autoSaveSettings()))
                }, null, 8, ["modelValue", "checked"])
              ])
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}